import React from 'react';
import { Control, Controller, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import { AgentFormValues } from '../../interfaces/types';

type AgentFormTextboxProps = {
  control: Control<AgentFormValues, any>;
  name: keyof AgentFormValues;
  rules: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  isEditDisabled: boolean | undefined;
  styles: CSSModuleClasses;
  inputLabel: string;
  placeholder: string;
  validationMessage: string;
  isRequired?: boolean;
  onChangeCallback?: (value: string) => void;
  isUpperCaseRequired?: boolean;
};

const AgentFormTextbox: React.FC<AgentFormTextboxProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled,
    styles,
    inputLabel,
    placeholder,
    validationMessage,
    isRequired = true,
    isUpperCaseRequired = false,
    onChangeCallback
  } = props;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, ref } }) => (
          <BorderedInput
            ref={ref}
            inputLabel={inputLabel}
            placeholder={placeholder}
            inputSize="medium"
            fullWidth={true}
            required={isRequired}
            disabled={isEditDisabled}
            containerClassName={cx(
              styles.textBoxClassContainer,
              'w-11/12',
              isEditDisabled ? styles.disabledTextBoxClassContainer : '',
              { [styles.uppercase]: isUpperCaseRequired && value }
            )}
            value={value}
            onFocus={e => e}
            onChange={e => {
              onChange(e.target.value);
              onChangeCallback?.(e.target.value);
            }}
            error={errors && errors[name] && errors[name].message}
          />
        )}
      />
      {errors && errors[name] && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AgentFormTextbox;
